const PROTECTED_ROUTES = new Set(["/profile", "/dashboard/[[...tab]]"]);

export default PROTECTED_ROUTES;
